import AtriumApi from "api";
import DarkButton from "components/actions/DarkButton";
import Loader from "components/loader/Loader";
import Switch from "components/switch";
import { useAuth } from "hooks/useAuth";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";

const NotificationSettings = () => {
  const [emailToggle, setEmailToggle] = useState(false);
  const [smsToggle, setSmsToggle] = useState(false);
  const [loading, setLoading] = useState(false);
  const [updateLoading, setUpdateLoading] = useState(false);

  const { user } = useAuth();
  const id = user?.id;

  // get user profile

  const getUserProfile = async () => {
    try {
      setLoading(true);
      const response = await AtriumApi.get("/v1/users/get-profile");
      if (response) {
        setLoading(false);
        setEmailToggle(response?.data?.user?.emailNotification);
        setSmsToggle(response?.data?.user?.smsNotification);
      }
    } catch {
      setLoading(false);
      console.log("error while getting user profile");
    }
  };
  useEffect(() => {
    getUserProfile();
  }, []);

  // toggle email and sms notifications
  const toggleEmail = async () => {
    try {
      setUpdateLoading(true);
      const payload = {
        smsNotification: smsToggle,
        emailNotification: emailToggle,
      };
      const response = await AtriumApi.patch(`/v1/users/update/${id}`, payload);
      if (response) {
        setUpdateLoading(false);
        toast.success(response?.data?.message);
        getUserProfile();
      }
    } catch (error) {
      setUpdateLoading(false);
      console.log("error while toggling email and sms", error);
      toast.error(error?.response?.data?.message);
    }
  };

  return (
    <div className="w-full block md:flex flex-row relative items-start rounded-[15px] p-3 md:p-[30px] gap-[30px] shadow-atrium shadow-shadow-500 dark:!bg-navy-800 dark:shadow-none mb-5">
      {loading ? (
        <div className="w-full h-full flex justify-center items-center">
          <Loader />
        </div>
      ) : (
        <>
          <div className="flex-1 mb-6">
            <h2 className="font-bold text-lg mb-2">Notification Settings</h2>
            <p className="text-gray-700 text-sm">
              Choose which notifications you want to receive and how you’d like
              to be notified.
            </p>
          </div>

          <div className="flex flex-col gap-4 flex-2">
            <div className="w-full flex flex-row text-gray-700 font-medium text-sm pb-4 uppercase">
              <p className="flex-1">Notification type</p>
              <p className="w-24">EMAIL</p>
              <p className="w-24">SMS</p>
            </div>

            <div className="w-full flex flex-row font-medium text-sm pb-4">
              <div className="flex-1">
                <p className="font-bold text-base dark:text-white">
                  New messages
                </p>
                <p className="text-gray-700 text-sm">
                  Notifications about new messages
                </p>
              </div>
              <p className="w-24">
                <Switch
                  checked={emailToggle}
                  onChange={(e) => setEmailToggle(e.target.checked)}
                ></Switch>
              </p>
              <p className="w-24">
                <Switch
                  checked={smsToggle}
                  onChange={(e) => setSmsToggle(e.target.checked)}
                ></Switch>
              </p>
            </div>

            {/* <div className="w-full flex flex-row font-medium text-sm border-b border-gray-100 dark:border-gray-700 pb-4">
                    <div className="flex-1">
                        <p className="font-bold text-base dark:text-white">New messages</p>
                        <p className="text-gray-700 text-sm">Notifications about new messages</p>
                    </div>
                    <p className="w-24"><Switch></Switch></p>
                    <p className="w-24"><Switch></Switch></p>
                </div>

                <div className="w-full flex flex-row font-medium text-sm border-b border-gray-100 dark:border-gray-700 pb-4">
                    <div className="flex-1">
                        <p className="font-bold text-base dark:text-white">New messages</p>
                        <p className="text-gray-700 text-sm">Notifications about new messages</p>
                    </div>
                    <p className="w-24"><Switch></Switch></p>
                    <p className="w-24"><Switch></Switch></p>
                </div>

                <div className="w-full flex flex-row font-medium text-sm pb-4">
                    <div className="flex-1">
                        <p className="font-bold text-base dark:text-white">New messages</p>
                        <p className="text-gray-700 text-sm">Notifications about new messages</p>
                    </div>
                    <p className="w-24"><Switch></Switch></p>
                    <p className="w-24"><Switch></Switch></p>
                </div> */}

            <div>
              <DarkButton disabled={updateLoading} onClick={toggleEmail}>
                {updateLoading ? "Saving..." : "Save changes"}
              </DarkButton>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default NotificationSettings;
